import { keysToCamelCase } from "zod-to-camel-case";

import type {
  MvLessonRestrictionLevels,
  MvLessonRestrictionLevelsCamel,
} from "@/schema/published/mvLessonRestrictionLevels/mvLessonRestrictionLevels.schema";

export const mvLessonRestrictionLevelsFixture = ({
  overrides = {},
}: {
  overrides?: Partial<MvLessonRestrictionLevels>;
} = {}): MvLessonRestrictionLevels => ({
  lesson_id: 1,
  _state: "published",
  slug: "test-lesson",
  tpc_media_max_restriction: "OGL compatible",
  tpc_quizimages_max_restriction: null,
  tpc_downloadablefiles_max_restriction: "Restricted",
  tpc_works_max_restriction: null,
  ...overrides,
});

export const mvLessonRestrictionLevelsFixtureCamel = ({
  overrides = {},
}: {
  overrides?: Partial<MvLessonRestrictionLevelsCamel>;
} = {}): MvLessonRestrictionLevelsCamel => ({
  ...keysToCamelCase(mvLessonRestrictionLevelsFixture()),
  ...overrides,
});
